import { create } from "zustand";

// Accent presets mirror the Claude Design "Tweaks" panel options. Each is an
// RGB triplet ("r g b") consumed by the --ef-accent* CSS vars (and therefore by
// the whole ef-accent* Tailwind palette + gradients).
export interface AccentPreset {
  id: string;
  label: string;
  accent: string; // "r g b"
  accent2: string; // "r g b"
  swatch: string; // hex for the picker dot
}

export const ACCENT_PRESETS: AccentPreset[] = [
  { id: "teal", label: "Teal", accent: "34 197 176", accent2: "168 114 241", swatch: "#22C5B0" },
  { id: "blue", label: "Blue", accent: "91 141 239", accent2: "168 114 241", swatch: "#5B8DEF" },
  { id: "purple", label: "Purple", accent: "168 114 241", accent2: "91 141 239", swatch: "#A872F1" },
  { id: "amber", label: "Amber", accent: "245 165 36", accent2: "168 114 241", swatch: "#F5A524" },
  { id: "green", label: "Green", accent: "34 197 94", accent2: "34 197 176", swatch: "#22C55E" },
];

const STORAGE_KEY = "ef_accent";

function applyAccent(preset: AccentPreset): void {
  const root = document.documentElement;
  root.style.setProperty("--ef-accent", preset.accent);
  root.style.setProperty("--ef-accent2", preset.accent2);
}

interface ThemeState {
  accentId: string;
  setAccent(id: string): void;
  init(): void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  accentId: "teal",
  setAccent(id) {
    const preset = ACCENT_PRESETS.find((p) => p.id === id) ?? ACCENT_PRESETS[0]!;
    applyAccent(preset);
    try {
      localStorage.setItem(STORAGE_KEY, preset.id);
    } catch {
      /* ignore quota / privacy-mode errors */
    }
    set({ accentId: preset.id });
  },
  init() {
    let stored: string | null = null;
    try {
      stored = localStorage.getItem(STORAGE_KEY);
    } catch {
      stored = null;
    }
    const preset = ACCENT_PRESETS.find((p) => p.id === stored) ?? ACCENT_PRESETS[0]!;
    applyAccent(preset);
    set({ accentId: preset.id });
  },
}));
